module.exports = __webpack_public_path__ + "static/media/wishesIconDropdown.0a10a185.svg";